// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4482":"4907d543","6088":"b197dec3"}[chunkId] + ".chunk.css";
};